import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { SchoolServiceData } from "../models/school-service-data.model";

export namespace SchoolServiceActions {

  @logDispatcher
  export class SetSchoolServicesDefaultState {
    static readonly type = '[SchoolService] SetSchoolServicesDefaultState';
    constructor() {}
  }

  @logDispatcher
  export class SetSchoolServicesAddFormDefaultState {
    static readonly type = '[SchoolService] SetSchoolServicesAddFormDefaultState';
    constructor() {}
  }

  @logDispatcher
  export class AddSchoolService {
    static readonly type = '[SchoolService] AddSchoolService';
    constructor(public schoolService: SchoolServiceData, public user: string) {}
  }

  @logDispatcher
  export class AddSchoolServiceSuccess {
    static readonly type = '[SchoolService] AddSchoolServiceSuccess';
    constructor(public schoolService: SchoolServiceData) {}
  }

  @logDispatcher
  export class EditSchoolService {
    static readonly type = '[SchoolService] EditSchoolService';
    constructor(public schoolService: SchoolServiceData, public user: string) {}
  }

  @logDispatcher
  export class EditSchoolServiceSuccess {
    static readonly type = '[SchoolService] EditSchoolServiceSuccess';
    constructor(public schoolService: SchoolServiceData) {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[SchoolService] Error';
    constructor(public error: any) {}
  }
}
